namespace RecordShield.Administration {

    @Serenity.Decorators.registerClass()
    export class UserGrid extends Serenity.EntityGrid<UserRow, any> {
        protected getColumnsKey() { return "Administration.User"; }
        protected getDialogType() { return UserDialog; }
        protected getIdProperty() { return UserRow.idProperty; }
        protected getIsActiveProperty() { return UserRow.isActiveProperty; }
        protected getLocalTextPrefix() { return UserRow.localTextPrefix; }
        protected getService() { return UserService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        private rowSelection: Serenity.GridRowSelectionMixin;
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }

        protected getButtons() {
            // preserving default New Item button
            var buttons = super.getButtons();
            debugger;
                buttons.push({
                    title: 'Import From Excel',
                    cssClass: 'export-xlsx-button',
                    onClick: () => {
                        debugger;
                        // open import dialog, let it handle rest
                        var dialog = new UserExcelImportDialog();
                        dialog.element.on('dialogclose', () => {
                            this.refresh();
                            dialog = null;
                        });
                        dialog.dialogOpen();
                    }
            });
                if (Authorization.hasPermission("Administration:Tenants") == false) {
                    buttons.splice(0, 4);
            }
            buttons.push(RecordShield.Common.ExcelExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                service: 'Administration/User/ListExcel',
                separator: true
            }));
            buttons.push({
                title: 'Unblock User',
                cssClass: 'edit-button',
                onClick: () => {
                    debugger;
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0 || rowKeys.length > 1) {
                        Q.alert("Please select single User to Unblock!");
                        return;
                    }
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    var key = this.rowSelection.getSelectedKeys()[0];
                    var entity;
                    RecordShield.Administration.UserService.Retrieve({
                        EntityId: key
                    }, response => {
                        entity = response.Entity;
                        Q.serviceRequest('Administration/User/UnblockUser', {
                            EntityId: key,
                            Entity: entity
                        }, (response) => {
                            this.rowSelection.resetCheckedAndRefresh();
                            this.refresh();
                        });
                    });


                }
            });
          
            return buttons;
        }

        protected getDefaultSortBy() {
            return [UserRow.Fields.Username];
        }
    }
}